// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"06cd6fb1","41":"1670b893","631":"c4ded2ab","653":"a372199c","731":"d45d9354","742":"25d00902","945":"6bbc7578","975":"d34a1216"}[chunkId] + ".chunk.js";
};